/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookEventCreateRequest as ModelsWebhookWebhookEventCreateRequest } from '../../models/Models/Webhook/webhook-event-create-request';
import { WebhookEventCreateRequestBaseResponse as ModelsWebhookWebhookEventCreateRequestBaseResponse } from '../../models/Models/Webhook/webhook-event-create-request-base-response';

export interface V4WebhooksRegisterPost$Xml$Plain$Params {
      body?: ModelsWebhookWebhookEventCreateRequest
}

export function v4WebhooksRegisterPost$Xml$Plain(http: HttpClient, rootUrl: string, params?: V4WebhooksRegisterPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4WebhooksRegisterPost$Xml$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>;
    })
  );
}

v4WebhooksRegisterPost$Xml$Plain.PATH = '/v4/webhooks/register';
